import { ResponsivePlot } from "@focus/focusGrafos";
import { useBahnPlot } from "../../hooks/useBahnPlot";
import { useEffect } from "react";
import { ItemStatus, StatusProxy } from "@focus/focusUI";

export const BahnPlot = ({ id }: { id: number }) => {
  const { config, data, status, error, loadBahnPlot } = useBahnPlot();

  useEffect(() => {
    loadBahnPlot(id);
  }, [id]);

  return (
    <StatusProxy status={status} error={error}>
      <div
        className="foc-detail-main-content"
        style={{
          marginBottom: "50px",
          height: "600px",
        }}
      >
        {data && config && (
          <ResponsivePlot
            data={data}
            plt={undefined}
            pltAvailable={false}
            config={config}
          />
        )}
      </div>
    </StatusProxy>
  );
};
